import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import 'normalize.css';
import App from './App';
import registerVuetify from './vuetify';

import {
	httpRequestInterceptor,
	httpResponseInterceptor,
	httpResponseSuccessInterceptor,
} from './http/index';
import registerAxios from './axios';
import vueRouter from './router';
import globalMixin from './mixins/global';
import registerFilters from './filters/global';
import './global-components';
import store from './store';

Vue.use(VueAnalytics, {
	id: 'UA-XXXXXXX-1',
	autoTracking: {
		screenview: true,
	},
	disableScriptLoader: true,
	sendHitTask: window.location.hostname === 'apprunn.netlify.com',
});

Vue.use(VueAwesomeSwiper);

const router = vueRouter(Vue);
registerFilters(Vue);
registerAxios(Vue);
registerVuetify(Vue);
Vue.prototype.$imageUrl = process.env.S3_IMAGES_URL;
Vue.prototype.$bus = new Vue();
Vue.config.productionTip = false;
Vue.mixin(globalMixin);
Vue.use(VueAwesomeSwiper);

async function created() {
	this.$http.interceptors.request.use(this.httpRequestInterceptor);
	this.$http.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpAcl.interceptors.request.use(this.httpRequestInterceptor);
	this.$httpAcl.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
}

/* eslint-disable no-new */
new Vue({
	created,
	el: '#app',
	methods: {
		httpRequestInterceptor,
		httpResponseInterceptor,
		httpResponseSuccessInterceptor,
	},
	router,
	render: h => h(App),
	store,
});



// WEBPACK FOOTER //
// ./src/main.js